import { complex, add, multiply, exp } from "mathjs";

const IDFTOfMagnitudes = (points) => {
  //MODIFIED BY CHATGPT, PREVIOUSLY DID NOT HAVE "-1"
  const N = Object.keys(points).length - 1;

  // Generate a sequence of complex numbers with given magnitudes and random phases
  const complexSequence = Object.values(points).map((magnitude) => {
    const randomPhase = Math.random() * 2 * Math.PI;
    const re = magnitude * Math.cos(randomPhase);
    const im = magnitude * Math.sin(randomPhase);
    return complex(re, im);
  });

  // Compute the inverse discrete Fourier transform of the complex sequence
  const result = [];
  for (let n = 0; n < N; n++) {
    let sum = complex(0, 0);
    for (let k = 0; k < N; k++) {
      const phi = (2 * Math.PI * k * n) / N;
      const c = multiply(complexSequence[k], exp(complex(0, phi)));
      sum = add(sum, c);
    }
    const x = multiply(sum, 1 / N);

    // Discard the imaginary part or round the real part to a suitable number of decimal places
    result.push(Math.round(x.re * 1e10) / 1e10);
  }
  return result;
};
export default IDFTOfMagnitudes;
